import { combineReducers } from "redux";
import NetPositions from "./Reducers/NetPositions";
import portfolioCompositionReducer from "./Reducers/PortfolioComposition";
import ContributionReducer from "./Reducers/Contribution";
import IndexDetails from "./Reducers/IndexDetails";
import MarketMapPlReducer from "./Reducers/MarketMapPl";
import DiversifyPortfolioReducer from "./Reducers/DiversifyPortfolio";
import AllIndicesListReducer from "./Reducers/AllIndexList";
import ServiceListReducer from "./Reducers/ServiceList";
import UpcomingEventsReducer from "./Reducers/UpcomingEvents";
export default combineReducers({
    NetPositions,
    portfolioCompositionReducer,
    ContributionReducer,
    IndexDetails,
    MarketMapPlReducer,
    ServiceListReducer,
    DiversifyPortfolioReducer,
    AllIndicesListReducer,
    UpcomingEventsReducer
});
